import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";

export async function getBodyPartsService(id = false) {
  const userId = await getLoggedInUser()._id;

  let url = getApiUrl() + "/users/" + userId + "/getbodypart/" + id;
  return await fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function getBodySymptomService(
  bodyPart,
  symptom,
  location = false
) {
  const userId = await getLoggedInUser()._id;
  //https://api-dev.12u12.com/1/users/04200000271/getsymptombybodypart/20000012060/20000011948/?location=20000012084

  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/getsymptombybodypart/" +
    bodyPart +
    "/" +
    symptom +
    "/?location=" +
    location;
  if (!location) {
    url =
      getApiUrl() +
      "/users/" +
      userId +
      "/getsymptombybodypart/" +
      bodyPart +
      "/" +
      symptom;
  }
  return await fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/services/BodyService.js